<template>
  <fieldset class="fieldset">
    <div class="field">
      <div class="control radio-list">
        <button 
          v-for="(label, value) in stepOptions.allSizes" 
          :key="value" 
          @click="chooseSize(value)" 
          class="select-card size flex items-start  lg:items-center justify-between mb-3 hover:shadow transition-all font-rubik"
          :class="updates.size == value ? 'size-active' : 'size-inactive'"
          style="width: 100% !important;"
        >
          <span :class="['size-label', updates.size == value ? 'text-[#1049FB]' : 'text-[#334155]']">{{ label }}</span>
          <span>
            <img class="h-[42px]" :src="getSizeIcon(value)" alt="Container size" />
          </span>
          <span class="container-sizes-text text-start lg:text-center" v-html="containerSizesText(value)"/>
        </button>

        <button
          @click="chooseSize('CUSTOM')" 
          class="select-card size flex items-start justify-start lg:items-center lg:justify-between mb-4 mt-12 gap-2 hover:shadow transition-all font-rubik"
          :class="updates.size == 'CUSTOM' ? 'size-active' : 'size-inactive'"
          style="width: 100% !important;"
        >
          <div>
            <span :class="['size-label', updates.size == 'CUSTOM' ? 'text-[#4D84FF]' : 'text-[#334155]']">Custom sizes available</span>
            <button class="custom-action-button transition-all flex justify-center items-center mt-1">
              <p>Talk to a Sales Rep</p>
            </button>
          </div>
          <img class="h-[42px]" :src="getSizeIcon('CUSTOM')" alt="Custom container size" />
        </button>
      </div>
    </div>
  </fieldset>
</template>

<script>
import { DynamicStep } from './mixin'
import size_10 from '@/images/get-quote-modal/container-sizes/10.svg'
import size_20 from '@/images/get-quote-modal/container-sizes/20.svg'
import size_40 from '@/images/get-quote-modal/container-sizes/40.svg'
import size_45 from '@/images/get-quote-modal/container-sizes/45.svg'
import size_custom from '@/images/get-quote-modal/container-sizes/custom.svg'
import size_10_active from '@/images/get-quote-modal/container-sizes/10-active.svg'
import size_20_active from '@/images/get-quote-modal/container-sizes/20-active.svg'
import size_40_active from '@/images/get-quote-modal/container-sizes/40-active.svg'
import size_45_active from '@/images/get-quote-modal/container-sizes/45-active.svg'
import size_custom_active from '@/images/get-quote-modal/container-sizes/custom-active.svg'

export default {
  mixins: [ DynamicStep('size') ],
  data() {
    return {
      containerSizes: {
        '10': size_10,
        '20': size_20,
        '40': size_40,
        '45': size_45,
        'CUSTOM': size_custom
      },
      containerSizesActive: {
        '10': size_10_active,
        '20': size_20_active,
        '40': size_40_active,
        '45': size_45_active,
        'CUSTOM': size_custom_active
      }
    }
  },
  methods: {
    isOption (hash) {
      return Object.keys(hash).length > 0
    },
    chooseSize(value) {
      this.updates.size = value
    },
    containerSizesText(size) {
      switch (size) {
      case '10':
        return '<span>10’ x 8’ x 8’6” standard <br> 563.3 cu. ft standard</span>'
      case '20':
        return '<span>20’ x 8’ x 8’6” standard <br> 1,158 cu. ft  standard</span><span class="mt-1 block">20’ x 8’ x 9’6” high cube <br> 1,318 cu. ft  high cube</span>'
      case '40':
        return '<span>40’ x 8’ x 8’6” standard <br> 2,332 cu. ft  standard</span><span class="mt-1 block">40’ x 8’ x 9’6” high cube <br> 2669 cu. ft  high cube</span>'
      case '45':
        return '<span>45’ x 8’ x 9’6” high cube <br> 3,040 cu. ft  high cube</span>'
      default:
        return ''
      }
    },
    getSizeIcon(size) {
      return this.updates.size == size ? this.containerSizesActive[size] : this.containerSizes[size]
    }
  }
}
</script>

<style lang="scss" scoped>
  .checkout-custom-modal .select-card.size {
    padding-left: 1.625rem !important;
    padding-right: 0.75rem !important;
    height: 6.5rem;
    border: 1px solid transparent;
     @media (max-width: 480px) {
      flex-direction: column;
      height: auto;

      span {
        margin-bottom: 0.5rem;
      }
    }
  }

  .size-active {
    border: 2px solid #1049FB !important;
  }

  .checkout-custom-modal .select-card.size-active,
  .cart-container .select-card.size-active,
  .retrieve-quote-modal .select-card.size-active {
    border: 2px solid #1049FB !important;
  }

  .size-label {
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: -0.04em;
  }

  .container-sizes-text {
    font-size: 10px !important;
    font-weight: 400 !important;;
    line-height: 10px !important;;
    color: #334155 !important;;
  }

  .custom-action-button {
    width: 100%;
    height: 44px;
    background: #4D84FF;
    border-radius: 999px;
    border: 1px solid #4D84FF;
  }
  .custom-action-button:hover {
    background: #1e44f1 !important;
    border: 1px solid #1e44f1 !important;
  }
  .custom-action-button p {
    color: #FFFFFF;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -0.0125em;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
  }
</style>